import { gql } from "@apollo/client";

export const GET_NOTIFICACION_INGRESO_INDICACION = gql`
query GetNotificacionesIngresoIndicacion($idDelegacion: Int!, $tipoNotificacionFiltro: TipoNotificacionAsistencialFiltro!, $idEstadoValidacion: Int!, $from: CustomDateTime!, $to: CustomDateTime!) {
    notificationsRIIndicaciones(
        idDelegacion: $idDelegacion, 
        tipoNotificacionFiltro: $tipoNotificacionFiltro,
        idEstadoValidacion: $idEstadoValidacion, 
        from: $from, 
        to: $to
    ) {
        success
        error
        valorEsperado {
            idEvaluacion
            idControlRI
            idDatosGenerales
            tipoNoticacion
            delegacion
            idDelegacion
            tipoEvaluacion
            idTipoModulo
            programa
            codSap
            cliente
            hC
            paciente
            estadoValidacion
            idMotivoNoIngreso
            motivoNoIngreso
            idMotivoDemora
            motivoDemora
            idMotivoRechazo
            motivoRechazo
            estadoRI
            estadoCoordinador
            profesionalASignado
            fechaLimite
            fechaRealizacion
            idMisTareas
            direccionRI
            observaciones
            franjaEtaria
            numeroDocumento
            fechaNacimiento
            edad
            telefonoContacto
            familiar
            familiarTelefono
            fechaNotificacion
            observacionSolicitudCorreccion
            rI
        }
    }
}
`;